var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jobs-select-dialog',{attrs:{"title":"Add to Scoop?","actionButtonText":"Apply","value":_vm.value,"jobs":_vm.jobs},on:{"action":_vm.onActionClick,"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }